import { render, staticRenderFns } from "./NordCourseListPage.vue?vue&type=template&id=6e0ed18c&"
import script from "./NordCourseListPage.vue?vue&type=script&lang=js&"
export * from "./NordCourseListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0ed18c')) {
      api.createRecord('6e0ed18c', component.options)
    } else {
      api.reload('6e0ed18c', component.options)
    }
    module.hot.accept("./NordCourseListPage.vue?vue&type=template&id=6e0ed18c&", function () {
      api.rerender('6e0ed18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordCourseListPage.vue"
export default component.exports